import React, { useEffect, useState } from "react";
import Button from 'Components/Button';
import sadface from 'Assets/img/icon-sad.png';
import globalLogoImg from 'Assets/img/global-payments-logo.png';
import citiLogoImg from 'Assets/img/citi_logo.jpg';
import DisputesIcon from 'Components/icons/disputes-icon/DisputesIcon';
import './Maintenance.scss';
import { VITE_MAINTENANCE_TITLE, VITE_MAINTENANCE_REASON, VITE_MAINTENANCE_TILL, VITE_CITI_BRANDED_URL } from 'Constants/appEnvConstants';

const Maintenance = () => {

  return (
    <article className="maintenance__wrapper">
    <div className="disputes-brand">
            <svg className="disputes-icon" style={{ width: 40,height: 40,left: 10,top: 40,position: 'fixed'}} viewBox="0 0 38 38">
              <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M7.09024 19.5376C7.09024 12.815 12.5524 7.30033 19.3275 7.30033C19.9577 7.30033 20.588 7.35285 21.1657 7.45789C19.7476 3.0987 15.6511 0 10.8717 0C4.88439 0 0 4.88439 0 10.9242C0 15.6511 3.04618 19.6951 7.2478 21.2182C7.14276 20.6405 7.09024 20.1153 7.09024 19.5376Z" fill="white" />
              <path fillRule="evenodd" clipRule="evenodd" d="M19.5284 1.37122C9.45295 1.37122 1.26666 9.52614 1.26666 19.6152C1.26666 29.7043 9.45295 37.8593 19.5284 37.8593C29.6038 37.8593 37.7901 29.7043 37.7901 19.6152C37.7901 9.52614 29.6038 1.37122 19.5284 1.37122ZM21.9948 10.3625L24.8285 14.7536L23.0443 15.9037L20.2106 11.5126L21.9948 10.3625ZM10.1351 17.9947L12.9689 22.3858L14.753 21.2358L11.9193 16.8447L10.1351 17.9947ZM12.7589 16.3219L19.3709 12.0353L22.2047 16.4265L15.5927 20.713L12.7589 16.3219ZM18.3739 20.138L24.0938 28.9202L26.7176 27.1951L20.9977 18.4129L18.3739 20.138Z" fill="#583b7e" />
            </svg>
            <img
                src={`https://${window.location.hostname}`.includes(VITE_CITI_BRANDED_URL) ? citiLogoImg : globalLogoImg}
                alt="Global Payments"
                className="global-payments-logo"
                style={{position:'fixed',top:40,left:60}}
    />
     
    <p className="maintenance__brand">Disputes Management System</p>
        </div>
   
      <section className="maintenance__content">
      <div>
      <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="138.000000pt" height="139.000000pt" viewBox="0 0 138.000000 139.000000" preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,139.000000) scale(0.100000,-0.100000)" fill="#583b7e" stroke="none">
          <path d="M520 1365 c-244 -68 -429 -252 -496 -495 -28 -101 -24 -272 8 -372 60 -181 181 -327 338 -406 211 -106 410 -108 620 -5 78 38 109 60 176 127 131 132 192 269 201 451 6 131 -13 222 -73 345 -78 157 -215 277 -386 337 -61 22 -93 27 -203 30 -94 2 -145 -1 -185 -12z m291 -285 c119 -37 222 -140 259 -259 97 -309 -192 -598 -501 -501 -119 37 -222 140 -259 259 -97 309 192 598 501 501z"/>
          <path d="M530 812 c-46 -37 9 -106 59 -75 26 16 26 59 -1 77 -28 20 -31 20 -58 -2z"/>
          <path d="M792 814 c-27 -18 -27 -61 -1 -77 50 -31 105 38 59 75 -27 22 -30 22 -58 2z"/>
          <path d="M595 576 c-41 -18 -95 -65 -95 -82 0 -28 29 -26 67 4 21 17 57 35 81 42 54 14 113 -1 165 -42 38 -30 67 -32 67 -4 0 18 -55 65 -97 83 -41 17 -149 16 -188 -1z"/>
        </g>
      </svg>
      </div>
        {VITE_MAINTENANCE_TITLE}
        <CountdownTimer />
        <div className="smallText">
        <p dangerouslySetInnerHTML={{__html: VITE_MAINTENANCE_REASON}} />
        </div>
        <br />
 
      </section>
    </article>
  );
};

export default Maintenance;



function CountdownTimer() {
  const calculateTimeLeft = () => {
    const date=new Date(VITE_MAINTENANCE_TILL);
    const difference = +date - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
  });

  const timerComponents = [];

  Object.keys(timeLeft).forEach(interval => {
    if (!timeLeft[interval]) {
      return;
    }

    timerComponents.push(
      <span>
        {timeLeft[interval]} {interval}{" "}
      </span>
    );
  });

  return (
    <div style={{fontWeight: 600}}>
      {timerComponents.length ? timerComponents : <span>sometime!</span>}
    </div>
  );
}

